import { FiExternalLink, FiHelpCircle } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import Tooltip from '~/components/Tooltip'
import { FormGroup, Label } from '~/components/unform'
import { Container as ContainerInput } from '~/components/unform/Input/styles'

const DestinationUrlRow = ({
  url,
  name,
  inputLabel,
  children
}: {
  url?: string | null
  name?: string | null
  inputLabel?: string
  children?: React.ReactNode
}) => (
  <FormGroup className="d-flex flex-column gap-2">
    {name && (
      <Label>
        {name}{' '}
        <Tooltip
          text={t('rm:adDestination.descriptionWithBrand', {
            brand: name
          })}
          icon={<FiHelpCircle />}
        />
      </Label>
    )}

    {children ?? (
      <ContainerInput isDisabled>
        {url ? (
          <div className="htmlIcon">
            <Button
              as="a"
              href={url}
              target="_blank"
              rel="noreferrer"
              text={t('rm:accessLink')}
              iconRight={<FiExternalLink />}
              size="xsmall"
              template="secondary"
              customWidth="auto"
              style={{ padding: '0 .25rem', marginRight: '.25rem' }}
            />
          </div>
        ) : null}

        <input value={url ?? ''} aria-label={inputLabel} disabled />
      </ContainerInput>
    )}
  </FormGroup>
)

export default DestinationUrlRow
